(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Exchangerate', Exchangerate);

    Exchangerate.$inject = ['$resource', 'DateUtils'];

    function Exchangerate ($resource, DateUtils) {
        var resourceUrl =  'api/exchangerates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.pubDate = DateUtils.convertDateTimeFromServer(data.pubDate);
                        data.lastEdited = DateUtils.convertDateTimeFromServer(data.lastEdited);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
